<template>
  <div>
    <div class="panel" v-if="!isLoading">
      <div v-if="items.length > 0" class="d-flex flex-wrap">
        <card-box
          class="col-lg-6"
          v-for="item of items"
          :key="item.id"
          :item="item"
          :active="activeIndex"
          @cardclick="onCardClick"
        ></card-box>
      </div>
      <div v-else>
        <span class="text-secondary">No category available...</span>
      </div>
    </div>
    <div class="spinner" v-else>
      <spinner :theme="primary" /><span class="text-secondary">
        Loading, please wait...</span
      >
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
import axios from "@/helpers/axios";
import _ from "lodash";
import CardBox from "./CardBox";
import { config } from "../helpers/slick";

export default {
  name: "card-box-panel",
  components: {
    CardBox,
    Spinner
  },
  props: {
    condition: {
      type: [Object],
      default: null
    }
  },
  data: () => ({
    slickOptions: {},
    items: [],
    activeIndex: -1,
    isLoading: true
  }),
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  async created() {
    this.slickOptions = config;
    await this.fetch();
    this.isLoading = false;
  },
  methods: {
    async fetch() {
      await this.paginated(this.condition);
    },
    onCardClick(id) {
      this.activeIndex = id;
      var name = _.find(this.items, { id }).name;
      this.$emit("category", { id, name });
    },
    async paginated({ page, size, collection, action }) {
      const { data, meta } = await axios
        .get(`/${collection}?page[number]=${page}&page[size]=${size}${action}`)
        .then(response => response.data);
      const collections = data.filter(item => item.Products.length > 0);
      for (let col of collections) {
        var locations = [];
        await axios.get(`/categories/${col.id}/locations`).then(response => {
          locations = response.data.data;
        });
        if (locations.length > 0) {
          this.items.push(col);
        }
      }

      if (meta.hasNextPage) {
        await this.paginated({ page: page + 1, size, collection, action });
      }
    }
  }
};
</script>

<style lang="scss">
@import "node_modules/slick-carousel/slick/slick.scss";
.panel {
  .slick-next {
    right: -35px !important;
  }
  .slick-prev {
    left: -35px !important;
  }
  @media (max-width: 769px) {
    .slick-next {
      right: -15px !important;
    }
    .slick-prev {
      left: -15px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.spinner {
  display: flex;
  align-items: center;
}
</style>
